
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 10 10"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M7.769 6.385l1.385-.347.346 1.385","fill":"none","stroke":"currentColor","stroke-linecap":"round","stroke-linejoin":"round"}}),_c('path',{attrs:{"d":"M9.012 6.074A4.17 4.17 0 015 9.154h0a4.17 4.17 0 01-3.9-2.735M2.231 3.615l-1.385.347L.5 2.577","fill":"none","stroke":"currentColor","stroke-linecap":"round","stroke-linejoin":"round"}}),_c('path',{attrs:{"d":"M.988 3.926A4.17 4.17 0 015 .846h0a4.17 4.17 0 013.9 2.735","fill":"none","stroke":"currentColor","stroke-linecap":"round","stroke-linejoin":"round"}})])
          )
        }
      }
    